var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 687.01 195.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "currentColor",
    d: "M211.48 137.62V147a10.86 10.86 0 0 1-10.86 10.86H121A10.87 10.87 0 0 1 110.11 147v-9.41a30.42 30.42 0 0 1 30.41-30.42h3.78a39.39 39.39 0 0 0 33 0h3.78a30.42 30.42 0 0 1 30.4 30.45ZM131.84 71a29 29 0 1 1 29 29 29 29 0 0 1-29-29ZM333.29 137.62V147a10.87 10.87 0 0 1-10.86 10.86h-79.65A10.86 10.86 0 0 1 231.92 147v-9.41a30.42 30.42 0 0 1 30.41-30.42h3.78a39.39 39.39 0 0 0 33 0h3.78a30.43 30.43 0 0 1 30.4 30.45ZM253.64 71a29 29 0 1 1 29 29 29 29 0 0 1-29-29ZM455.09 137.62V147a10.87 10.87 0 0 1-10.86 10.86h-79.65A10.86 10.86 0 0 1 353.72 147v-9.41a30.42 30.42 0 0 1 30.41-30.42h3.78a39.39 39.39 0 0 0 33 0h3.78a30.42 30.42 0 0 1 30.4 30.45ZM375.44 71a29 29 0 1 1 29 29 29 29 0 0 1-29-29ZM576.89 137.62V147A10.86 10.86 0 0 1 566 157.89h-79.62A10.87 10.87 0 0 1 475.52 147v-9.41a30.42 30.42 0 0 1 30.41-30.42h3.78a39.39 39.39 0 0 0 33 0h3.78a30.42 30.42 0 0 1 30.4 30.45ZM497.24 71a29 29 0 1 1 29 29 29 29 0 0 1-29-29Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "99.65672302px",
      lineHeight: 1.25,
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial Bold'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "currentColor",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.445 85.734v-18.54H569.76V54.396h18.686v-18.54h12.457v18.54h18.734v12.798h-18.734v18.54z",
    style: {
      strokeWidth: 1
    },
    "aria-label": "+"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser04);
export default __webpack_public_path__ + "static/media/user_04.a701eab9ce41312e536e09afbf32fdb1.svg";
export { ForwardRef as ReactComponent };